import classNames from 'classnames';
import { use100vh } from 'react-div-100vh';
import {
  IoIosCheckmarkCircleOutline,
  IoIosCloseCircleOutline,
} from 'react-icons/io';
import './styles.scss';

import Button from 'src/legacy/Components/Forms/Button';
import { Icon } from '@chakra-ui/react';
import { PiWarningCircle } from 'react-icons/pi';

const status = {
  success: {
    icon: <Icon as={IoIosCheckmarkCircleOutline} boxSize={118} />,
    color: 'green',
    buttonText: 'Ver meus ingressos',
  },
  denied: {
    icon: <Icon as={IoIosCloseCircleOutline} boxSize={118} />,
    color: 'red',
    buttonText: 'Tentar novamente',
  },
  warning: {
    icon: <Icon as={PiWarningCircle} boxSize={118} />,
    color: 'yellow',
    buttonText: 'Ver meus ingressos',
  },
  generic: {
    icon: <Icon as={PiWarningCircle} boxSize={118} />,
    color: 'orange',
    buttonText: 'Ver meus ingressos',
  },
  openError: {
    color: 'purple',
    buttonText: 'Tentar novamente',
  },
};

export default function ColoredOverlayWindow({
  children,
  requestStatus,
  show,
  title = '',
  goToPage,
  buttonText,
  ...rest
}) {
  const height = use100vh();

  return (
    <div
      className={classNames(
        `checkout-feedback ${status[requestStatus].color}`,
        { show },
      )}
      style={{ height: height ? `${height}px` : '100vh' }}
      {...rest}>
      <div className="center">
        {status[requestStatus].icon}
        <h1 style={{ marginTop: 0 }}>{title || status[requestStatus].title}</h1>
        <div className="box">
          <p style={{ textAlign: 'center' }}>{children}</p>
          <Button fullWidth={true} color="blue" onClick={goToPage}>
            {buttonText || status[requestStatus].buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
}
